import { Suspense, useMemo } from 'react'

import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { useGetTemplatesSummary } from '@/catalog-apps/components/SupportPanel/TemplatesV2/useGetTemplatesSummary'
import { DataTable } from '@/components/ui/DataTable'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { WorkspaceDataTemplatesFilters } from './WorkspaceDataTemplatesTable/WorkspaceDataTemplatesFilters'
import { workspaceDataTemplatesTableColumns } from './WorkspaceDataTemplatesTable/workspaceDataTemplatesTableColumns'
import { getWorkspaceDataTemplatesFilterOptions } from './WorkspaceDataTemplatesTable/workspaceDataTemplatesTableUtils'

export function WorkspaceDataTemplatesPage() {
  return (
    <>
      <WorkspacesBreadcrumbs title="Data Templates" />
      <QueryErrorBoundary errorMessage="Failed to fetch data templates">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceDataTemplatesPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceDataTemplatesPanelContent() {
  const { app_id, project_id } = useCurrentWorkspace()
  const { data: summary } = useGetTemplatesSummary({ appId: app_id, projectId: project_id })
  const filterOptions = useMemo(() => getWorkspaceDataTemplatesFilterOptions(summary), [summary])

  return (
    <TablePageContainer>
      <DataTable
        columns={workspaceDataTemplatesTableColumns}
        data={summary}
        filters={(table) => (
          <WorkspaceDataTemplatesFilters
            table={table}
            {...filterOptions}
          />
        )}
        defaultSortColumnId="date"
        defaultSortDesc
      />
    </TablePageContainer>
  )
}
